import debounce from "debounce";

import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import { useTranslation } from "react-i18next";

const EditGroupName = ({ onNameChange, isChangingName }) => {
	const { t } = useTranslation();

	return (
		<Box
			sx={{
				display: "flex",
				alignItems: "center",
				justifyContent: "start",
				gap: "6px",
				paddingRight: isChangingName ? 0 : "26.4px",
			}}
		>
			<Typography component="span" sx={{ whiteSpace: "nowrap" }}>
				{t("group_name")}:
			</Typography>
			<TextField
				variant="outlined"
				margin="none"
				size="small"
				required
				fullWidth
				id="email"
				name="email"
				autoComplete="email"
				autoFocus
				onChange={debounce((e) => onNameChange(e), 700)}
				error={false}
				helperText={""}
			/>
			{isChangingName && (
				<Box>
					<CircularProgress size={20} />
				</Box>
			)}
		</Box>
	);
};

export default EditGroupName;
